import React from "react";

export const actionType = {
  PENDING_OPERATIONS_START: "INVENTORY/PENDING_OPERATIONS_START",
  PENDING_OPERATIONS: "INVENTORY/PENDING_OPERATIONS",

  PENDING_OPERATIONS_LIST_START: "INVENTORY/PENDING_OPERATIONS_LIST_START",
  PENDING_OPERATIONS_LIST: "INVENTORY/PENDING_OPERATIONS_LIST"
};
